import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Upload } from 'antd';

import AntIcon from '../../shared/components/AntIcon';
import { formItemLayout, getValidationState, wrapFormItemInput } from '../../shared/utils/form_components';

function isHttpUrl(value) {
  return typeof value === 'string' && /^https?:\/\//i.test(value.trim());
}

/**
 * redux-form Field: pick a shoes image file to send with campaign create/update multipart.
 * Existing server URL (string) is shown as preview; a new File replaces it on save.
 */
export default function ShoesImageField(props) {
  const { input, meta, label, extra } = props;
  const [objectUrl, setObjectUrl] = useState('');

  const value = input.value;
  const file = typeof File !== 'undefined' && value instanceof File ? value : null;
  const existingUrl = isHttpUrl(value)
    ? value.trim()
    : (isHttpUrl(meta.initial) ? String(meta.initial).trim() : '');
  const previewUrl = isHttpUrl(value) ? value.trim() : '';

  useEffect(() => {
    if (!file) {
      setObjectUrl('');
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const previewSrc = objectUrl || previewUrl || (!file ? existingUrl : '');

  const beforeUpload = (nextFile) => {
    input.onChange(nextFile);
    input.onBlur();
    return false;
  };

  const clearFile = () => {
    input.onChange(isHttpUrl(meta.initial) ? String(meta.initial).trim() : null);
  };

  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      extra={extra}
      validateStatus={getValidationState(meta)}
      help={meta.touched ? meta.error : null}
    >
      <Row gutter={8} type="flex" align="middle">
        <Col xs={24} sm={14}>
          {wrapFormItemInput(
            <span className="ant-form-text" style={{ wordBreak: 'break-all' }}>
              {file
                ? file.name
                : existingUrl || 'No shoes image selected'}
            </span>,
          )}
        </Col>
        <Col xs={24} sm={10}>
          <Upload accept="image/*" showUploadList={false} beforeUpload={beforeUpload}>
            <Button htmlType="button">
              <AntIcon type="upload" /> Choose image
            </Button>
          </Upload>
          {file && (
            <Button htmlType="button" style={{ marginLeft: 8 }} onClick={clearFile}>
              Clear
            </Button>
          )}
        </Col>
      </Row>
      {previewSrc && (
        <div style={{ marginTop: 8 }}>
          <img
            src={previewSrc}
            alt="Shoes preview"
            style={{ maxWidth: '100%', width: 'auto', maxHeight: 140, objectFit: 'contain', borderRadius: 4 }}
            referrerPolicy="no-referrer"
          />
        </div>
      )}
    </Form.Item>
  );
}
